'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {
        required: false,
    });

    const values = {};
    for (const r of config.rows) {
        const x = _.find(config.choices, {id: input && input[r.id]});
        values[r.id] = (x && x.id) || null;
    }

    const choicesWithOccurrencies = config.choices.filter((c) => c.occurrencies > 0);
    if (choicesWithOccurrencies.length > 0) {
        choicesWithOccurrencies.forEach((cwo) => {
            const occurrencies = _.pickBy(values, (value) => value == cwo.id);
            const occurrenciesRows = Object.keys(occurrencies);
            if (occurrenciesRows.length > cwo.occurrencies) {
                throw new ParserError(PARSER_ERRORS.OCCURRENCIES, [{errorRows: occurrenciesRows}]);
            }
        });
    }

    if (config.required && _.some(values, (v) => !v)) {
        const missing = Object.entries(values).filter(([, v]) => !v).map(([k]) => k);
        throw new ParserError(PARSER_ERRORS.REQUIRED, [{errorRows: missing}]);
    }

    return values;
};
